/** Util for URL-tokens for state management */
export default class TokenUtils {
  /** Default length of an URL-token */
  static readonly DEFAULT_TOKEN_LENGTH = 20
  /** Query-param key for token */
  static readonly TOKEN_KEY = 'state'

  /** generates a random token */
  // do we have to care for collisions? maybe check for existing tokens (in a service) and make sure, that new tokens don't match new ones?
  static generateToken(length: number = 20): string {
    // https://gist.github.com/6174/6062387#gistcomment-2762722
    const radom13chars = function () {
      return Math.random().toString(16).substring(2, 15)
    }
    const loops = Math.ceil(length / 13)
    return new Array(loops)
      .fill(radom13chars)
      .reduce((string, func) => {
        return string + func()
      }, '')
      .substring(0, length)
  }

  /** Generates random token and returns an object to be handed to the [queryParams] property of the routerLink-directive. */
  static generateTokenAsRoutingParam(length: number = 20): { token: string } {
    return { token: TokenUtils.generateToken(length) }
  }
}
